import axios from "axios";
import { FetchInstallments } from "@/services/DataService";
import {IInstallment} from "@/types/IInstallment";
import { IBaseInstallmentParams } from "@/types/IBaseInstallment";
import {IAuthError, ILoginCredentials} from "@/types/auth";
import authHelper from "@/helpers/authHelper";
import { ISession } from "@/types/ISession";

const HTTP_METHOD_POST = "POST";
const SHARED_PASSWORD = process.env.VUE_APP_MIDDLEWARE_SHARED_SECRET || "";

export class APIInstallmentsData implements FetchInstallments {
  async fetchData(params: IBaseInstallmentParams): Promise<IInstallment> {
    try {
      const credentials: ILoginCredentials = {
        deviceTag: params.deviceTag,
        sharedSecret: SHARED_PASSWORD,
        optionName: params.paymentOption,
      };
      const response = await authHelper.login(credentials);

      const session: ISession = response.session;

      return session.installment;
    } catch (error: unknown) {
      if (error instanceof IAuthError) {
        console.error(`Authentication failed: ${error.message}`);
      }
      throw error;
    }
  }
}

export class LocalInstallmentsData implements FetchInstallments {
  async fetchData(params: IBaseInstallmentParams): Promise<IInstallment> {
    // Fetch the installments from a JSON file named deviceTag value .json
    const response = await axios.get(`/assets/${params.deviceTag}.json`);
    return response.data.installments;
  }
}
